var Config = {
	debug_mode : true
}